import createIcon from '@/lib/create-icon'

const NetballIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M30.125 37.7083L33 18.5417H13.8333L16.7083 37.7083L23.4167 31L30.125 37.7083ZM30.125 37.7083L14.7917 22.3742M20.5417 18.5418L30.7253 28.7254M15.75 17.0415V12.5415C15.75 11.483 15.75 8 18.9167 8H27.9167C31.0833 8 31.0833 11.483 31.0833 12.5415V17.0415M36.8333 18.5417H10'
      stroke='url(#paint0_linear_5314_518)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M30.125 37.7083L33 18.5417H13.8333L16.7083 37.7083L23.4167 31L30.125 37.7083ZM30.125 37.7083L14.7917 22.3742M20.5417 18.5418L30.7253 28.7254M15.75 17.0415V12.5415C15.75 11.483 15.75 8 18.9167 8H27.9167C31.0833 8 31.0833 11.483 31.0833 12.5415V17.0415M36.8333 18.5417H10'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M30.125 37.7083L33 18.5417H13.8333L16.7083 37.7083L23.4167 31L30.125 37.7083ZM30.125 37.7083L14.7917 22.3742M20.5417 18.5418L30.7253 28.7254M15.75 17.0415V12.5415C15.75 11.483 15.75 8 18.9167 8H27.9167C31.0833 8 31.0833 11.483 31.0833 12.5415V17.0415M36.8333 18.5417H10'
      stroke='url(#paint1_radial_5314_518)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_518'
        x1='10'
        y1='8'
        x2='42.63'
        y2='28.4668'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_518'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.4167 37.7083) scale(13.4167 15.1286)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'NetballIcon'
)

export default NetballIcon
